import OtherCollegeNavigation from './OtherCollegeNavigation';

export { type OtherCollegeNavigationProps } from './OtherCollegeNavigation';
export default OtherCollegeNavigation;
